import React, { useContext, useState, useEffect, useRef, useMemo, useCallback } from "react";
import { IconButton, Table, TableHead, TableBody, TableRow, TableCell, Paper, Menu, MenuItem, TableSortLabel, TextField, Tooltip, ButtonGroup, Box, Typography, } from "@mui/material";
import useTradeCell from "../../tablecells/Trade";
import { ThemeContext } from "../../../context/ThemeContext";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { openModal } from "../../../store/Slices/modalSlice";
import AccountFooter, { profitLoss } from "../../footer/AccountFooter";
import { ArrowRight } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check"
import { useTranslation } from "react-i18next";
import { closeOrderPosition, closeAllPrositionsByHedge, closePositionByHedge, OneClickTrading } from "../../../api/request/dashboard/dashboard";
import CloseIcon from "@mui/icons-material/Close";
import '../../../App.scss'
import { Search } from "@mui/icons-material";
import toast from 'react-hot-toast';
import Checkbox from '@mui/material/Checkbox';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Order from './order/Orders'
import { TableVirtuoso } from "react-virtuoso";
import { deletePositionsData } from "../../../store/Slices/orderPositionSlice";
import NoDataTable from "../../table/NoDataTable";
import CloseByHedgeModal from "../../modal/CloseByHedge";
import EditPositionModal from "../../modal/EditSLTP/EditPositionModal";
import { getCookies } from "../../../services/Cookies";


export default function Trade({ handleOpenModifyPositionModal, handleChartFromTradeTabClick }) {
  const { darkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => state.modal.isModalOpen);
  const [contextMenu, setContextMenu] = useState(null);
  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const { t } = useTranslation()
  const { accountId } = useSelector(state => state.accountSummary)
  const [hoveredRow, setHoveredRow] = useState(null);
  const [hoveredCell, setHoveredCell] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const TradeCell = useTradeCell();
  const [totalProfit, setTotalProfit] = useState(0);
  const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
  const orderSLTP = useSelector((state) => state.orderPosition.orderSLTP, shallowEqual);
  const { symbols } = useSelector(state => state.watchlist)
  const [hedgeModalOpen, setHedgeModalOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const clientId = getCookies("clientId");
  const componentName = 'Trade'
  const storageKey = `hiddenColumns_${clientId}_${componentName}`;

  const handleContextMenu = (event, row) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      row,
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
    setSubmenuAnchor(null);
  };

  const toggleColumnVisibility = (title) => {
    setVisibleColumns((prev) => {
      const updatedColumns = { ...prev, [title]: !prev[title] };

      const hiddenColumns = Object.keys(updatedColumns).filter(col => !updatedColumns[col]);
      localStorage.setItem(storageKey, JSON.stringify(hiddenColumns));

      return updatedColumns;
    });
  };
  const handleCreateNewOrderClick = () => {
    console.log('Before condition:', isModalOpen);
    if (!isModalOpen) {
      console.log('Dispatching openModal...');
      dispatch(openModal());
    }

    if (!isModalOpen) {
      console.log('calling...', isModalOpen);
      dispatch(openModal());
    }
  };

  const handleCloseClick = async (rowIndex = null, orderId = null) => {
    const ordersToClose = orderId
        ? [orderId]
        : rowIndex !== null
            ? [positions[rowIndex]?.id]
            : selectedRows;

    if (ordersToClose.length === 0) {
        toast.error("No orders selected");
        return;
    }

    const closeRequests = ordersToClose.map(async (orderId) => {
        const selectedRow = positions.find(row => row.id === orderId);
        if (!selectedRow) return { success: false, positionId: orderId };

        const closeOrderPayload = {
            accountId: Number(accountId),
            positionId: selectedRow.id,
            amount: selectedRow.amount,
        };

        try {
            const response = await closeOrderPosition(closeOrderPayload);
            if (response.status === 200) {
                dispatch(deletePositionsData(orderId));
                return { success: true, positionId: orderId, position: selectedRow };
            }
        } catch (error) {
            console.error("Error closing order:", error);
        }
        return { success: false, positionId: orderId, position: selectedRow };
    });

    const results = await Promise.allSettled(closeRequests);

    results.forEach(({ status, value }) => {
        if (status === "fulfilled" && value?.success) {
            const { positionId, position } = value;
            if (position) {
                const { symbolId, symbolName, side } = position;
                const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;
                const tradeSide = side === 1 ? "Buy" : "Sell";

                toast.success(`Closed Trade #${positionId} (${symbolName}) at ${price}, ${tradeSide}`);
            }
        } else {
            const { positionId, position } = value;
            if (position) {
                const { symbolId, symbolName, side } = position;
                const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;

                toast.error(` Failed to close Trade #${positionId} (${symbolName}) at ${price}`);
            }
        }
    });

    setSelectedRows([]);
    selectedRowsRef.current = [];
    setForceUpdate(prev => !prev);
    handleCloseContextMenu();
};

  const getInitialVisibleColumns = () => {
    const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey));
    if (storedHiddenColumns) {
      return TradeCell.reduce((acc, col) => ({
        ...acc,
        [col.title]: !storedHiddenColumns.includes(col.title)
      }), {});
    }
    return TradeCell.reduce((acc, col) => ({ ...acc, [col.title]: true }), {});
  };
  const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);

  const resetAllColumns = () => {
    const resetColumns = TradeCell.reduce((acc, col) => ({ ...acc, [col.title]: true }), {});
    setVisibleColumns(resetColumns);
    localStorage.removeItem(storageKey);
  };

  const handleMouseEnter = useCallback((rowIndex, cellIndex) => {
    setHoveredRow(rowIndex);
    setHoveredCell(cellIndex);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoveredRow(null);
    setHoveredCell(null);
  }, []);


  const handleModifyClick = () => {
    console.log('Clicked Modify', contextMenu.row);

    if (!contextMenu?.row) return;
    const sltpExists = orderSLTP.some((sltp) => sltp.positionId === contextMenu.row.id);

    if (sltpExists) {
      toast.error("Position is already managed.");
    } else {
      const orderDetails = {
        row: contextMenu.row,
      };
      handleOpenModifyPositionModal(orderDetails);
    }

    // Close the context menu
    handleCloseContextMenu();
  };

  const sortTradeData = useMemo(() => {
    if (!Array.isArray(positions)) return [];

    return [...positions].sort((a, b) => {
      if (!sortConfig.key) return 0;
      const valueA = a[sortConfig.key];
      const valueB = b[sortConfig.key];

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
      }
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
      return 0;
    });
  }, [positions, sortConfig]);


  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const handleToggleSearchBar = () => {
    setShowSearchBar((prev) => {
      if (prev) setSearchQuery("");
      return !prev;
    });
  };

  const filteredData = useMemo(() => {
    return sortTradeData.filter((row) =>
      TradeCell.some((col) => row[col.dataIndex]?.toString().toLowerCase().includes(searchQuery.toLowerCase()))
    );
  }, [sortTradeData, searchQuery]);

  const [selectedRows, setSelectedRows] = useState([]);
  const allSelected = selectedRows.length === filteredData.length && filteredData.length > 0;

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) => {
      const updated = prev.includes(rowId)
        ? prev.filter(id => id !== rowId)
        : [...prev, rowId];

      selectedRowsRef.current = updated;

      // console.log("Row selected:", rowId, "Updated selectedRows:", updated);
      return updated;
    });
  };

  const handleSelectAll = () => {
    const newSelected = allSelected ? [] : [...filteredData.map(row => row.id)];
    console.log("Updated selectedRows (Select All):", newSelected);
    setSelectedRows([...newSelected]);
  };

  const selectedRowsRef = useRef(new Set());
  const [forceUpdate, setForceUpdate] = useState(false);
  // console.log(positions);

  const closeProfitablePositions = async () => {
    const profitableTrades = [...profitLoss]
      .filter((value) => parseFloat(value[1]) > 0)
      .map(([id, pl]) => {
        const position = positions.find(pos => pos.id === id);
        // console.log(positions)

        if (!position) return null;
        return {
          accountId: accountId,
          amount: position.amount,
          positionId: position.id,
        };
      })
      .filter(Boolean);

    if (profitableTrades.length === 0) {
      toast.error("No profitable positions found!");
      return;
    }

    try {
      const results = await Promise.allSettled(
        profitableTrades.map(trade => closeOrderPosition(trade))
      );

      // Extract successfully closed positions
      const successfulTrades = profitableTrades.filter((_, index) => results[index].status === "fulfilled");
      if (successfulTrades.length > 0) {
        successfulTrades.forEach(trade => {
          const position = positions.find(pos => pos.id === trade.positionId);
          if (position) {
            toast.success(`Closed Trade #${trade.positionId} (${position.symbolName}) at ${position.side === 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask}} ,${position.side === 1 ? "Buy" : 'Sell'} `);
          }
        });

        // toast.success(`${successfulTrades.length} profitable position(s) closed!`);
      } else {
        toast.error("Failed to close profitable positions.");
      }
      // Dispatch delete only for successful closures
      successfulTrades.forEach(trade => dispatch(deletePositionsData(trade.positionId)));


    } catch (error) {
      console.error("Error closing profitable positions:", error);
      toast.error("An error occurred while closing positions.");
    } finally {
      handleCloseContextMenu();
    }
  };

  const closeUnprofitablePositions = async () => {
    const unprofitableTrades = [...profitLoss]
      .filter(([_, value]) => parseFloat(value) < 0)
      .map(([id, pl]) => {
        const position = positions.find(pos => pos.id === id);

        if (!position) return null;

        return {
          accountId: accountId,
          amount: position.amount,
          positionId: position.id,
        };
      })
      .filter(Boolean);

    if (unprofitableTrades.length === 0) {
      toast.error("No unprofitable positions found!");
      return;
    }
    try {
      const results = await Promise.allSettled(
        unprofitableTrades.map(trade => closeOrderPosition(trade))
      );

      // Extract successfully closed positions
      const successfulTrades = unprofitableTrades.filter((_, index) => results[index].status === "fulfilled");
      if (successfulTrades.length > 0) {
        // toast.success(`${successfulTrades.length} Unprofitable position(s) closed!`);
        successfulTrades.forEach(trade => {
          const position = positions.find(pos => pos.id === trade.positionId);
          if (position) {
            toast.success(`Closed Trade #${trade.positionId} (${position.symbolName}) at ${position.side === 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask}} ,${position.side === 1 ? "Buy" : 'Sell'} `);
          }
        });
      } else {
        toast.error("Failed to close unprofitable positions.");
      }
      // Dispatch delete only for successful closures
      successfulTrades.forEach(trade => dispatch(deletePositionsData(trade.positionId)));


    } catch (error) {
      console.error("Error closing unprofitable positions:", error);
      toast.error("An error occurred while closing positions.");
    }
    finally {
      handleCloseContextMenu();
    }

  };

  const closeAllByHedge = async (symbolId, amount) => {
    if (!symbolId) {
      toast.error("Invalid symbol ID.");
      return;
    }

    // Filter trades matching the selected symbolId
    const filteredTrades = positions
      .filter((item) => item.symbolId === symbolId)
      .map((position) => { // Extract trade ID
        return { firstPositionId: position?.id, secondPositionId: position?.id }; // Update as needed
      });
    if (filteredTrades.length === 0) {
      toast.error("No trades to close for this symbol.");
      return;
    }

    const payload = {
      orders: filteredTrades.map((trade) => ({
        accountId: accountId,
        amount: amount,
        firstPositionId: trade.firstPositionId,
        secondPositionId: trade.secondPositionId,
      })),
    };

    try {
      await closeAllPrositionsByHedge(payload);
      // toast.success("All trades closed successfully!");
      payload.orders.forEach(order => {
        const position = positions.find(pos => pos.id === order.firstPositionId);
        if (position) {
          toast.success(`Closed Hedge Trade #${order.firstPositionId} & #${order.secondPositionId} (${position.symbolName}) at ${position.side === 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask}} ,${position.side === 1 ? "Buy" : 'Sell'}`);
        }
      });

    } catch (error) {
      console.error("Error closing trades:", error);
      toast.error("Failed to close trades.");
    }
    handleCloseContextMenu();
  };

  const closePositionBy_Hedge = async (firstPositionId, secondPositionId, amount) => {
    if (!firstPositionId || !secondPositionId) {
      toast.error("Invalid position IDs.");
      return;
    }

    const payload = {
      accountId: accountId,
      amount: amount,
      firstPositionId,
      secondPositionId
    };

    try {
      const response = await closePositionByHedge(payload);;
      // toast.success(`Successfully closed positions: ${firstPositionId} & ${secondPositionId}`);
      const position = positions.find(pos => pos.id === firstPositionId);
      if (position) {
        toast.success(`Closed Hedge Trade #${firstPositionId} (${position.symbolName}) at ${position.side === 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask} ,${position.side === 1 ? "Buy" : 'Sell'}`);
      }

      return response.data;
    } catch (error) {
      console.error("Error closing position by hedge:", error);
      toast.error("Failed to close positions.");
    }
  };

  const doublePosition = async () => {
    if (!contextMenu?.row) {
      toast.error("Invalid trade data.");
      return;
    }

    const { accountId, symbolId, amount, side } = contextMenu.row;

    const payload = {
      accountId: accountId,
      side: side,
      amount: amount,
      symbolId: symbolId,
      comment: "Opened by Double Position",
    };

    try {
      await OneClickTrading(payload);
      // toast.success("Trade doubled successfully!");
      toast.success(`Doubled Trade #${contextMenu.row.id} (${contextMenu.row.symbolName}) at ${contextMenu.row.side === 1 ? symbols[contextMenu.row.symbolId].bid : symbols[contextMenu.row.symbolId].ask}}`);

    } catch (error) {
      console.error("Failed to double the position:", error);
      toast.error("Failed to double the position.");
    }
    finally {
      handleCloseContextMenu();
    }
  };

  const inversePosition = async () => {
    if (!contextMenu?.row) {
      toast.error("Invalid trade data.");
      return;
    }

    const { accountId, symbolId, amount, side, id } = contextMenu.row;

    const payload = {
      accountId: accountId,
      side: side === 1 ? -1 : 1,
      amount: amount,
      symbolId: symbolId,
      comment: `Inverse of trade #${id}`,
    };

    try {
      await OneClickTrading(payload);
      // toast.success(`Trade #${id} inverted successfully!`);
      toast.success(`Inverse Trade #${contextMenu.row.id} (${contextMenu.row.symbolId}) at ${contextMenu.row.side === 1 ? symbols[contextMenu.row.symbolId].bid : symbols[contextMenu.row.symbolId].ask}  ${contextMenu.row.side === 1 ? "Buy" : "Sell"}`);

    } catch (error) {
      console.error("Failed to invert the position:", error);
      toast.error("Failed to invert the position.");
    }
    finally {
      handleCloseContextMenu();
    }
  };

  const handleCloseByHedgeClick = () => {
    if (!contextMenu?.row?.id) {
      toast.error("Invalid position.");
      return;
    }

    const oppositePosition = positions.find(
      (pos) => pos.symbolId === contextMenu.row.symbolId && pos.side !== contextMenu.row.side
    );

    if (oppositePosition) {
      const { bid, ask, bidColor, askColor, digits } = symbols[contextMenu.row.symbolId] || {};

      if (bid !== undefined && ask !== undefined) {
        setSelectedPosition({ ...contextMenu.row, bid, ask, bidColor, askColor, digits });
        setHedgeModalOpen(true);
        handleCloseContextMenu();
      } else {
        toast.error("Bid and ask prices not available.");
      }
    } else {
      toast.error("No opposite positions available for hedge.");
    }
  };
  const [openEdit, setOpenEdit] = useState(false);
  const [editSLTP, setEditSLTP] = useState([]);

  const handleEditClick = () => {
    if (!contextMenu?.row) return;

    const sltpData = orderSLTP.filter((sltp) => sltp.positionId === contextMenu.row.id);
    if (sltpData.length > 0) {
      setEditSLTP(sltpData);
      setOpenEdit(true);
      handleCloseContextMenu();

    } else {
      toast.error("No S/L, T/P to edit");
    }
  };


  const Row = useMemo(() => (index, row) => {
    return <>
      <TableCell padding="checkbox" sx={{ border: 'none', padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", }}>
        <Checkbox checked={selectedRows.includes(row.id)} onChange={() => handleRowSelect(row.id)} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 12, }, }} />
      </TableCell>

      {TradeCell.filter(col => visibleColumns[col.title])
        .map((col, colIndex) => {
          return visibleColumns[col.title] && (
            // <>
            <TableCell key={`${row.id}-${colIndex}`} onContextMenu={(event) => handleContextMenu(event, row)} selected={selectedRows.includes(row.id)} sx={{ fontSize: "0.8rem", border: 'none', padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: 'hidden' }}>
              {col.render(row[col.dataIndex], row)}
            </TableCell>
            // </>
          );
        })}
    </>
  }, [selectedRows, orderSLTP, darkMode, visibleColumns])

  const fixedHeaderContent = () => {
    return <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }} >
      <TableCell padding="checkbox" sx={{ borderBottom: "1px solid rgba(224, 224, 224, 0.3)", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", fontWeight: 700 }}>
        <ButtonGroup variant="outlined" sx={{ display: "flex", alignItems: "center", gap: 1, border: 'none' }}>
          <Tooltip title={t('selectall')}>
            <Checkbox checked={allSelected} onChange={handleSelectAll} indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 14 } }} />
          </Tooltip>
          <Tooltip title={t('delete')}>
            <span>
              <IconButton onClick={() => handleCloseClick(null, selectedRows.id)} sx={{ color: "red", width: 24, height: 24 }} disabled={selectedRows.length === 0}><DeleteOutlinedIcon sx={{ fontSize: 14 }} /></IconButton>
            </span>
          </Tooltip>
        </ButtonGroup>
      </TableCell>
      {TradeCell.map(
        (col, index) => visibleColumns[col.title] && (
          <TableCell style={{ width: col?.width, fontWeight: 550, textTransform: "capitalize" }} key={index} sx={{ fontSize: "0.85rem", fontWeight: 200, p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", cursor: "pointer", borderBottom: "1px solid rgba(224, 224, 224, 0.3)", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, }} onClick={() => handleSort(col.dataIndex)}>
            <TableSortLabel active={sortConfig.key === col.dataIndex} direction={sortConfig.direction}>
              {col.title}
            </TableSortLabel>
          </TableCell>
        )
      )}
    </TableRow>
  }
  const VirtuosoTableComponents = {
    Table: (props) => (
      <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };
  return (
    <>
      <Paper style={{ width: "100%", height: "100%", position: 'relative', }}>
        <div style={{ position: "absolute", top: 10, right: 16, zIndex: 1000, display: "flex", alignItems: "center", transition: "width 0.4s ease-in-out", }}>
          {!showSearchBar && (
            <IconButton onClick={handleToggleSearchBar} sx={{ border: darkMode ? "1px solid #202933" : "1px solid #d5d5d5", borderRadius: "50%", transition: "opacity 0.3s ease-in-out", }}>
              <Search sx={{ fontSize: 18 }} />
            </IconButton>
          )}
          {showSearchBar && (
            <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 50, width: "250px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", marginLeft: "8px", padding: "2px 8px", transition: "all 0.3s ease-in-out", backgroundColor: darkMode ? "#202933" : "#d5d5d5" }}>
              <TextField name="searchQuery" size="small" variant="outlined" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1, }} />
              <IconButton onClick={handleToggleSearchBar}>
                <CloseIcon sx={{ fontSize: 15 }} />
              </IconButton>
            </Paper>
          )}
        </div>
        {filteredData.length === 0 ? (<NoDataTable columns={TradeCell} data={filteredData} noDataMessage={t('noData')} />
        ) : (
          <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%' }}>
            <TableVirtuoso data={filteredData} itemContent={Row} fixedHeaderContent={fixedHeaderContent} components={VirtuosoTableComponents}> </TableVirtuoso>
          </Box>
        )}
        <Box onContextMenu={(event) => handleContextMenu(event)} sx={{ padding: 0, backgroundColor: darkMode ? "#2b3543" : "var(--white)", }}>
          <Box sx={{ border: "none", p: "3px", backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }}>
            {/* <AccountFooter totalProfit={totalProfit} /> */}
            <Typography sx={{ fontSize: '0.8rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>Pending Orders</Typography>
          </Box>
        </Box>
        <Order />
      </Paper>
      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
        <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
          {/* <MenuItem sx={{ fontSize: 13.5 }} onClick={handleCreateNewOrderClick}>{t('newOrder')}</MenuItem> */}
          <MenuItem sx={{ borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, fontSize: 13.5 }} onClick={() => { handleChartFromTradeTabClick(contextMenu?.row?.symbolName, contextMenu?.row?.symbolId) }}>{t('chart')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={handleEditClick}>{t('editposition')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={handleModifyClick}>{t('modifyPosition')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={inversePosition}>{t('inversePosition')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={doublePosition}>{t('doublePosition')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={() => { handleCloseClick(null, contextMenu?.row.id) }}>{t("close")} ({contextMenu?.row.symbolName})</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={handleCloseByHedgeClick}>{t("closeByHedge")}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={() => closeAllByHedge(contextMenu?.row.symbolId, contextMenu?.row.amount)}>{t('closeAllByHedge')} ({contextMenu?.row.symbolName})</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={closeProfitablePositions}>{t('closeProfitablePosition')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={closeUnprofitablePositions}>{t('closeUnrofitablePosition')}</MenuItem>
          <MenuItem onClick={(e) => setSubmenuAnchor(e.currentTarget)} sx={{ fontSize: 13.5 }}>{t('columns')} <ArrowRight /></MenuItem>
        </div>
      </Menu>

      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={Boolean(submenuAnchor)} anchorEl={submenuAnchor} onClose={handleCloseContextMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
        <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
          {TradeCell.filter(col => col.title !== "Symbol" && col.title !== "Profit").map((col, index) => (
            <MenuItem key={index} onClick={() => toggleColumnVisibility(col.title)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", }}>
              {col.title} {visibleColumns[col.title] && (<CheckIcon sx={{ fontSize: 18, color: "#4597ff", }} />)}
            </MenuItem>))}
          <MenuItem onClick={resetAllColumns} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}>{t('resetAll')}</MenuItem>
        </div>
      </Menu>

      {hedgeModalOpen && (<CloseByHedgeModal open={hedgeModalOpen} onClose={() => setHedgeModalOpen(false)} selectedPosition={selectedPosition} closePositionBy_Hedge={closePositionBy_Hedge} />)}
      {openEdit && (<EditPositionModal open={openEdit} handleClose={() => setOpenEdit(false)} editSLTP={editSLTP} />)}
    </>
  );
}